<!-- <template>
  <div class="homePage">
    <div class="banner_">
      <img src="@/assets/images/homePage_banner.jpg" />
    </div>

    <div class="certificateView">
      <div class="left_">
        <img src="@/assets/images/homePage_certificate.png" />
      </div>
      <div class="right_">
        <div>24小时快速著作权数字证书由中国区块链中心确权</div>
        <div>不可篡改，放心使用</div>
      </div>
    </div>

    <div class="servesView">
      <div class="title_">
        <div>数字授权服务</div>
        <div>自主定价，分割授权</div>
      </div>

      <div class="threeView">
        <div class="itemWap" v-for="(item, index) in dataList" :key="index">
          <div class="itemTitle">
            {{ item.title }}
          </div>
          <div class="btn_">禁止了解更多</div>
          <div class="backGroundImg">
            <img :src="item.backgroundImg" />
          </div>
        </div>
      </div>
    </div>
    <div class="servesViewFooter">
        <div class="title_">作品推广服务</div>
        <img src="@/assets/images/homePage_service.png" />
      </div>
  </div>
</template>

<script>
export default {
  name: "homePage",
  data() {
    return {
      dataList: [
        {
          title: "信息网络传播权",
          backgroundImg: require("../assets/images/homePage_three_1.png"),
        },
        {
          title: "影视改编权",
          backgroundImg: require("../assets/images/homePage_three_2.png"),
        },
        {
          title: "演艺权等权利",
          backgroundImg: require("../assets/images/homePage_three_3.png"),
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.homePage {
  display: flex;
  flex-direction: column;
  align-items: center;
  .servesViewFooter {
    width: 100%;
    padding: 80px 0 68px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f3f9ff;
    margin-top: 52px;
    .title_ {
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      line-height: 48px;
      font-weight: 700;
    }
    img{
        width: 980px;
        margin-top: 16px;
    }
  }
  .servesView {
    margin-top: 46px;
    .threeView {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      .itemWap {
        width: 300px;
        height: 356px;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        .backGroundImg {
          width: 240px;
          img {
            width: 100%;
          }
        }
        .btn_ {
          width: 120px;
          height: 40px;
          border-radius: 8px;
          border: 2px solid #008aea;
          margin: 24px 0;
          font-family: AlibabaPuHuiTiM;
          color: #008aea;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
        .itemTitle {
          font-size: 30px;
          font-family: AlibabaPuHuiTiB;
          color: #303133;
        }
      }
      .itemWap:nth-of-type(1) {
        border-top: 8px #008aea solid;
      }
      .itemWap:nth-of-type(2) {
        border-top: 8px #3f70b6 solid;
        margin: 0 30px;
      }
      .itemWap:nth-of-type(3) {
        border-top: 8px #3a4a8a solid;
      }
    }
    .title_ {
      div {
        text-align: center;
        font-weight: 700;
      }
      div:nth-of-type(1) {
        font-size: 40px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
      }
      div:nth-of-type(2) {
        font-size: 24px;
        font-family: AlibabaPuHuiTiM;
        color: #008aea;
        line-height: 24px;
        margin-top: 12px;
      }
    }
  }
  .certificateView {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 70px;
    .right_ {
      width: 540px;
      div {
        font-weight: 700;
      }
      div:nth-of-type(1) {
        width: 100%;
        font-size: 40px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        line-height: 48px;
        margin-bottom: 12px;
      }
      div:nth-of-type(2) {
        width: 100%;
        font-size: 24px;
        font-family: AlibabaPuHuiTiM;
        color: #008aea;
      }
    }
    .left_ {
      width: 480px;
      font-size: 0;
      margin-right: 20px;
      img {
        width: 100%;
      }
    }
  }
  .banner_ {
    width: 100%;
    font-size: 0;
    img {
      width: 100%;
    }
  }
}
</style> -->
<template>
  <div class="page_">
    <div class="bannerContainer">
      <div class="left-wap">
        <div class="title_">
          <span>10分钟</span>完成版权登记<br />投稿给数千家媒体
        </div>

        <div style="color:#008AEA;font-size:14px;margin-top:8px;">以区块链技术为核心，高效进行确权登记、获取确权证书、在线投稿的自助一站式版权服务平台</div> 
        <!-- <div class="button_">
          <div>我要投稿</div>
          <div>确权登记</div>
        </div> -->
      </div>
      <div class="right_wap">
        <div class="title_">龙源版权确权平台</div>
        <div class="f3">
          <div>
            <img
              src="../assets/images/staticPage/homePage/loginIcon1.png"
            />确权
          </div>
          <div>
            <img
              src="../assets/images/staticPage/homePage/loginIcon2.png"
            />智能授权
          </div>
          <div>
            <img
              src="../assets/images/staticPage/homePage/loginIcon3.png"
            />智能投稿
          </div>
        </div>
        <div class="txt-container">
          一次注册，可登录全系列产品
          <!-- <span>
            了解更多
          </span> -->
        </div>
        <div class="input-container">
          <div class="input-container-title">用户名或手机号</div>
          <div class="input-container-input">
            <input type="text" v-model="pageData.phone" placeholder="用户名" />
          </div>
          <!-- <div class="input-container-radio">
            <div></div>记住我
          </div> -->
        </div>
        <div class="input-container" style="margin: 0 0 16px 0">
          <div class="input-container-title">密码</div>
          <div class="input-container-input">
            <input
              type="password"
              v-model="pageData.password"
              placeholder="密码"
            />
          </div>
          <!-- <div class="input-container-radio">
            <div></div>记住我
          </div> -->
        </div>
        <div class="loginBtn" @click="userLoginFun">登录</div>
        <div class="user-txt">
          <div class="user-txt-left">
            <!-- 选择登录即表示您同意我们的<span>条款</span>并已阅读并确认我们的<span>全球隐私声明</span> -->
          </div>
          <div class="user-txt-right">
            <div @click="routePush">忘记密码?</div>
            <div @click="pageJump('/registered?type=1')">注册</div>
          </div>
        </div>
      </div>
    </div>

    <div class="serveContainer">
      <div class="title_">选择服务</div>
      <div class="itemContainer">
        <div class="item" @click="pageJump('/contentChain')">
          <div class="item-title">确权登记</div>
          <div class="txt">只需10分钟就能完成</div>
          <div class="button_">免费开始</div>
          <div class="txt2">了解确权登记的好处</div>
          <img
            src="../assets/images/staticPage/homePage/serveIcon1.png"
            alt=""
          />
        </div>
        <div class="item" @click="pageJump('/contentChain')">
          <div class="item-title">我要投稿</div>
          <div class="txt">一键给提供给数千家刊社</div>
          <div class="button_">免费开始</div>
          <div class="txt2">了解使用智能投稿的好处</div>
          <img
            src="../assets/images/staticPage/homePage/serveIcon2.png"
            alt=""
          />
        </div>
        <div class="item" @click="pageJump('/contentChain')">
          <div class="item-title">购买确权使用</div>
          <div class="txt">保障内容</div>
          <div class="button_">开始全面服务</div>
          <div class="txt2">了解版权使用智能合约</div>
          <img
            src="../assets/images/staticPage/homePage/serveIcon3.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="valueManContainer">
      <div class="title_">
        <div>从版权到实现价值</div>
        <div>帮助作者实现版权价值</div>
      </div>
      <div class="container">
        <div class="leftContainer">
          <img src="../assets/images/staticPage/homePage/zxg.png" alt="" />
        </div>
        <div class="rightContainer">
          <div class="theTitle">通过全面服务，我的几个简单步骤</div>
          <div class="theContainer">
            <div class="left_">
              <img
                src="../assets/images/staticPage/homePage/zxgNumber.png"
                alt=""
              />
            </div>
            <div class="right_">
              <div>快速安全的上传确权您的作品</div>
              <div>让您可以设置不同是授权方式的价格和时间</div>
              <div>为您提供适合的版权使用方匹配</div>
              <div>为您清算稿费，让您随时了解版权变现</div>
            </div>
          </div>
          <div class="button_" @click="pageJump('/contentChain')">开始</div>
        </div>
      </div>
    </div>

    <div class="managerListContainer">
      <div class="title_">
        <div>加入数百万让版权管理更智能的人的行列</div>
        <div>客户评分为4.6星（满分5星）</div>
      </div>
      <div class="scoreList">
        <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
        <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
        <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
        <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
        <img src="../assets/images/staticPage/homePage/star2.png" alt="" />
      </div>
      <div class="ccoreNum">323602评论</div>
      <div class="listContainer">
        <div class="item_">
          <div class="scoreList">
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
          </div>
          <div class="itemTitle">投稿真方便！</div>
          <div class="introduce">
            投稿真方便！不用查找刊社的邮箱，我设置了1个月的独家期，让不同的刊社有收稿件的紧迫性。3个小时就有刊社采用了。
          </div>
          <div class="author_">
            <div class="cover"></div>
            <div class="txt">
              <div>作者</div>
              <div>蔡磊</div>
            </div>
          </div>
        </div>
        <div class="item_">
          <div class="scoreList">
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
          </div>
          <div class="itemTitle">保护了我自己</div>
          <div class="introduce">
            学术论文还没有获得发表前，先进行时间戳确权特别重要，这样就可以放心的在圈子里分享自己的成果。
          </div>
          <div class="author_">
            <div class="cover"></div>
            <div class="txt">
              <div>学术作者</div>
              <div>太顺敬</div>
            </div>
          </div>
        </div>
        <div class="item_">
          <div class="scoreList">
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
            <img src="../assets/images/staticPage/homePage/star1.png" alt="" />
          </div>
          <div class="itemTitle">超赞！！</div>
          <div class="introduce">
            终于有了一个只需要选好的稿件不用担心是否是抄袭的投稿渠道，节省了大量的时间
          </div>
          <div class="author_">
            <div class="cover"></div>
            <div class="txt">
              <div>读者杂志编辑</div>
              <div>于信</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rightsGuarantee">
      <div class="title_">权利与保证</div>

      <div class="list">
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-1.png" alt="" />
          <div>首都版权链</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-2.png" alt="" />
          <div>内容版权保护</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-3.png" alt="" />
          <div>稿酬</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-4.png" alt="" />
          <div>内容版权保护</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-5.png" alt="" />
          <div>内容版权保护</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
        <div class="item">
          <img src="../assets/images/staticPage/homePage/f6-6.png" alt="" />
          <div>内容版权保护</div>
          <div>
            我们会找到您有资格获得的每一项税收减免和抵免，以增加您的退税。
          </div>
        </div>
      </div>
    </div>
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>

<script>
import { userLogin } from "../api/interfaceList.js";
import { reactive } from "vue";
import marketingPageFooter from "@/components/marketingPageFooter.vue";
import { useRouter } from "vue-router";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";

import { useStore } from "vuex";

export default {
  name: "navigation",
  components: {
    marketingPageFooter,
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    const router = useRouter();
    const store = useStore();
    // const store = useStore();
    let pageData = reactive({
      phone: "",
      password: "",
    });
    const pageJump = (e) => {
      router.push(e);
    };
    function routePush() {
      router.push({
        path: "/login",
        query: {
          isForgotPasswordShow: 2,
        },
      });
    }
    function userLoginFun() {
      let { phone, password } = pageData;
      userLogin({
        phone,
        password,
      }).then((res) => {
        if (res.code == 1) {
          store.commit("isLoginSetting", false);
          Cookies.set("userInformation", JSON.stringify(res.data));
          if (
            res.data.isEnterpriseAuthentication == 1 ||
            res.data.isPersonalAuthentication == 1
          ) {
            router.push("/");
          } else {
            router.push("registered");
          }
        } else {
          ElMessage({
            message: res.message,
            type: "warning",
          });
        }
      });
    }
    return {
      pageData,
      pageJump,
      userLoginFun,
      routePush,
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {
  display: flex;
  flex-direction: column;
  align-items: center;

  .rightsGuarantee {
    // width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 0 68px;
    box-sizing: border-box;

    .title_ {
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      line-height: 48px;
      font-weight: 800;
    }

    .list {
      width: 960px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      .item {
        width: 300px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 40px;

        img {
          width: 160px;
        }

        div {
          width: 100%;
          text-align: center;
          font-weight: 800;
        }

        div:nth-of-type(1) {
          font-size: 20px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          margin: 8px 0 4px;
        }

        div:nth-of-type(2) {
          font-size: 15px;
          font-family: AlibabaPuHuiTiM;
          color: #606266;
          line-height: 21px;
        }
      }
    }
  }

  .managerListContainer {
    width: 100%;
    height: 760px;
    border-bottom: 1px #e6e6e6 solid;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .listContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32px;

      .item_ {
        width: 300px;
        height: 262px;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1),
          inset 0px 8px 0px 0px #008aea;
        padding: 30px;
        box-sizing: border-box;
        margin-right: 30px;

        .author_ {
          display: flex;
          align-items: center;

          .txt {
            font-weight: 700;

            div {
              font-size: 12px;
              font-family: AlibabaPuHuiTiM;
              color: #008aea;
            }

            div:last-of-type {
              // margin-top: 4px;
              font-size: 14px;
              font-family: AlibabaPuHuiTiM;
              color: #303133;
            }
          }

          .cover {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #333;
            margin-right: 8px;

            img {
              width: 100%;
            }
          }
        }

        .itemTitle {
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          margin: 16px 0 8px 0;
          font-weight: 800;
        }

        .introduce {
          height: 80px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          line-height: 20px;
          margin-bottom: 16px;
        }
      }

      .item_:last-of-type {
        margin: 0;
      }
    }

    .scoreList {
      display: flex;
      align-items: center;

      img {
        width: 24px;
      }
    }

    .title_ {
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      font-weight: 800;
      text-align: center;

      div:last-of-type {
        margin-top: 10px;
        font-size: 18px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
      }
    }

    .ccoreNum {
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #008aea;
      margin-top: 8px;
    }
  }

  .valueManContainer {
    width: 100%;
    padding: 80px 58px 70px 58px;
    box-sizing: border-box;
    background: #f5f7fa;

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 48px;
      width: 100%;

      .rightContainer {
        .button_ {
          width: 200px;
          height: 48px;
          background: #cc3f1f;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          line-height: 48px;
          text-align: center;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          cursor: pointer;
        }

        .theContainer {
          margin: 40px 0;
          display: flex;
          align-items: center;

          .right_ {
            height: 344px;
            margin-left: 24px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 13px 0;
            box-sizing: border-box;

            div {
              font-size: 18px;
              font-family: AlibabaPuHuiTiR;
              color: #303133;
              line-height: 24px;
            }
          }

          .left_ {
            height: 344px;

            img {
              height: 100%;
            }
          }
        }

        .theTitle {
          font-size: 18px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
        }
      }

      .leftContainer {
        width: 450px;
        margin-right: 135px;

        img {
          width: 100%;
        }
      }
    }

    .title_ {
      font-size: 24px;
      font-family: AlibabaPuHuiTiM;
      color: #cc3f1f;
      text-align: center;

      div:last-of-type {
        margin-top: 6px;
        font-size: 40px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        line-height: 48px;
        font-weight: 800;
      }
    }
  }

  .serveContainer {
    .itemContainer {
      display: flex;
      align-items: center;

      .item {
        font-weight: 500;
        width: 300px;
        height: 386px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        margin-right: 30px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        border-top: 8px #008aea solid;
        padding: 30px 0;
        cursor: pointer;

        .txt2 {
          font-size: 14px;
          font-family: AlibabaPuHuiTiR;
          color: #008aea;
          margin: 8px 0 16px;
        }

        .button_ {
          padding: 0 30px;
          text-align: center;
          height: 40px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #008aea;
          line-height: 40px;
          border: 2px #008aea solid;
          border-radius: 15px;
        }

        .txt {
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          margin: 8px 0 16px 0;
        }

        img {
          width: 180px;
        }

        .item-title {
          font-size: 30px;
          font-family: AlibabaPuHuiTiB;
          color: #303133;
        }
      }

      .item:nth-of-type(2) {
        border-top: 8px #ffb200 solid;
      }

      .item:nth-of-type(3) {
        border-top: 8px #cc3f1f solid;
        margin: 0;
      }
    }

    .title_ {
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      text-align: center;
      font-weight: 800;
      margin-bottom: 40px;
    }

    margin: 143px 0;
  }

  .bannerContainer {
    width: 100%;
    height: 680px;

    background: url("../assets/images/staticPage/homePage/bannerBg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    // padding: 0 70px;
    // box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    .right_wap {
      width: 432px;
      // height: 438px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 50px 36px 32px 36px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 30px;
      cursor: pointer;

      .user-txt {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .user-txt-right {
          display: flex;
          align-items: center;

          div {
            font-size: 12px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
            margin-right: 12px;
          }

          div:last-of-type {
            margin: 0;
          }
        }

        .user-txt-left {
          width: 225px;
          height: 32px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #909399;
          line-height: 16px;

          span {
            color: #008aea;
          }
        }
      }

      .loginBtn {
        width: 100%;
        height: 48px;
        background: #008aea;
        border-radius: 8px;
        line-height: 48px;
        text-align: center;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        margin-bottom: 24px;
      }
      .input-container {
        width: 100%;
        margin: 16px 0;

        .input-container-input {
          height: 40px;
          line-height: 40px;
          background: #ffffff;
          border-radius: 6px;
          border: 1.5px solid #cccccc;
          padding-left: 8px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #909399;

          input {
            width: 100%;
            height: 100%;
            outline: none;
            border: none;
            background: none;
          }
        }

        .input-container-title {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #909399;
          line-height: 12px;
          margin-bottom: 6px;
        }

        .input-container-radio {
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          font-weight: 800;
          display: flex;
          align-items: center;
          margin-top: 7px;

          div {
            width: 8px;
            height: 8px;
            border: 2px #909399 solid;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }

      .txt-container {
        width: 100%;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 14px;
        text-align: center;
        font-weight: 800;
        padding-bottom: 24px;
        border-bottom: 1px #e6e6e6 solid;

        span {
          color: #008aea;
          margin-left: 4px;
          text-decoration: underline;
        }
      }

      .f3 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 16px 0;

        div {
          width: 88px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          margin-right: 8px;

          img {
            width: 24px;
            margin-right: 8px;
          }
        }

        div:last-of-type {
          margin: 0;
        }
      }

      .title_ {
        font-size: 30px;
        font-family: AlibabaPuHuiTiB;
        color: #000000;
        line-height: 36px;
        text-align: center;
        font-weight: 800;
      }
    }

    .left-wap {
      width: 678px;

      .title_ {
        font-size: 60px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        line-height: 72px;
        font-weight: 800;

        span {
          color: #008aea;
        }
      }

      .button_ {
        margin-top: 24px;
        display: flex;
        align-items: center;

        div {
          width: 136px;
          height: 48px;
          line-height: 48px;
          background: #303133;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          text-align: center;
          margin-right: 32px;
          cursor: pointer;
        }

        div:last-of-type {
          margin: 0;
          background: #008aea;
        }
      }
    }
  }
}
</style>
